import React from 'react';
import { colors } from './theme';
import LoadingSpinner from './components/LoadingSpinner';
import { analyticsCardStyles as card } from './analytics/analyticsCardStyles';

export default function DataQualityAnalyticsCard({ average, loading }) {
  return (
    <div style={{ ...card.shell, maxWidth: '680px' }}>
      <div style={card.header}>
        <div style={card.titleWrap}>
          <p style={card.eyebrow}>Completeness</p>
          <h2 style={card.title}>Overall Data Quality Score</h2>
        </div>
      </div>
      <div style={{ ...card.body, textAlign: 'center' }}>
        {loading ? (
          <div style={{ ...card.section, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.5rem' }}>
            <LoadingSpinner size={24} />
            <span style={{ color: colors.textBody }}>Calculating average data quality...</span>
          </div>
        ) : average === null ? (
          <div style={card.section}>
            <p style={{ color: colors.textMuted, margin: 0 }}>N/A</p>
          </div>
        ) : (
          <div style={card.section}>
            <p title="Average of all device Data Quality Scores." style={{ fontSize: '2.5rem', fontWeight: 'bold', color: colors.textStrong, margin: 0 }}>
              {average} / 100
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
